export default __webpack_public_path__ + "static/media/banner_1.f56205dd.JPG";